
Game.Prefabs.Platform = function ( game, properties, group ) {

	if ( 'undefined' === typeof group ) {
		group = game.world;
	}

	if ( ! properties.key ) {
		properties.key = 'platform';
	}

	this.path = properties.polyline;

	Phaser.Sprite.call( this, game, properties.x + this.path[0][0], properties.y + this.path[0][1], 'empty' );

	this.image = game.add.sprite( this.x, this.y, properties.key );

	this.width = this.image.width;
	this.height = this.image.height;

	// Set platform physics.
	game.physics.arcade.enable( this );

	this.body.customSeparateX = true;
	this.body.customSeparateY = true;
	this.body.allowGravity = false;
	this.body.immovable = true;

	// Only top collision.
	this.body.checkCollision.down = false;
	this.body.checkCollision.left = false;
	this.body.checkCollision.right = false;

	this.addMotionPath();

	console.log( 'new platform', properties );

	group.add( this );
	group.add( this.image );

	this.image.anchor.setTo( 0.5, 0 );
	this.anchor.setTo( 0.5, 0 );

};

Game.Prefabs.Platform.prototype = Object.create( Phaser.Sprite.prototype );

Game.Prefabs.Platform.prototype.constructor = Game.Prefabs.Platform;


Game.Prefabs.Platform.prototype.preRender = function( man ) {

	// if ( man.lockedTo === this ) {
	// 	this.image.x = man.x;
	// } else {
	// }

	this.image.x = Math.round( this.x );
	this.image.y = Math.floor( this.y );

};


Game.Prefabs.Platform.prototype.addMotionPath = function() {

	this.tweenX = this.game.add.tween( this.body );
	this.tweenY = this.game.add.tween( this.body );

	var totalDistance = this.calculateDistance();
	var duration = ( totalDistance / 16 ) * 1000;

	var segmentDuration = 0;
	var segmentDistance = 0;

	// Calculate path distance.
	console.log( 'path distance', totalDistance, duration );

	this.delay();

	// Add motion path.
	// Start from 1 so that we skip the initial position.
	for ( var i = 1; i < this.path.length; i++ ) {

		segmentDistance = Math.distance( this.path[i-1][0], this.path[i-1][1], this.path[i][0], this.path[i][1] );
		segmentDuration = Math.round( ( segmentDistance / totalDistance ) * duration );

		this.tweenX.to( { x: this.x + this.path[i][0] }, segmentDuration );
		this.tweenY.to( { y: this.y + this.path[i][1] }, segmentDuration );

	}

	this.delay();

	// Loop backwards so we can get the yoyo effect.
	for ( var i = this.path.length - 2; i >= 0; i-- ) {

		segmentDistance = Math.distance( this.path[i+1][0], this.path[i+1][1], this.path[i][0], this.path[i][1] );
		segmentDuration = Math.round( ( segmentDistance / totalDistance ) * duration );

		this.tweenX.to( { x: this.x + this.path[i][0] }, segmentDuration );
		this.tweenY.to( { y: this.y + this.path[i][1] }, segmentDuration );

	}

	// Aaaaand, repeat.
	this.tweenX.repeatAll( -1 );
	this.tweenY.repeatAll( -1 );

	this.start();

};

Game.Prefabs.Platform.prototype.delay = function() {

	this.tweenX.to( { x: '+0' }, 1500 );
	this.tweenY.to( { y: '+0' }, 1500 );

};

Game.Prefabs.Platform.prototype.calculateDistance = function() {

	var totalDistance = 0;

	for ( var i = 0; i < this.path.length - 1; i++ ) {

		totalDistance += Math.distance( this.path[i][0], this.path[i][1], this.path[i+1][0], this.path[i+1][1] );

	}

	return totalDistance;

};

Game.Prefabs.Platform.prototype.start = function () {

	this.tweenX.start();
	this.tweenY.start();

};

Game.Prefabs.Platform.prototype.stop = function () {

	this.tweenX.stop();
	this.tweenY.stop();

};